import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { paymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateWithholdMerchantMutation = ({
	paidMonth,
	paidYear,
	onSuccessHandler,
}: {
	paidMonth: string;
	paidYear: string;
	onSuccessHandler?: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		(values: { [key: string]: any }) => {
			dispatch(uiActions.showSpinnerOverlay());

			return paymentsService.updateWithholdMerchant({
				values,
				paidYear,
				paidMonth,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Withhold Merchant has been updated successfully",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateWithholdMerchantMutation;
